import React from 'react';
import Icon from '../../../components/AppIcon';

const ViolationStatusOverview = ({ activeViolations, resolvedViolations, complianceScore, loading }) => {
  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-center py-12">
          <Icon name="Loader2" size={32} color="var(--color-primary)" className="animate-spin" />
        </div>
      </div>
    );
  }

  const getScoreColor = (score) => {
    if (score >= 95) return 'text-success';
    if (score >= 85) return 'text-warning';
    return 'text-error';
  };

  const getScoreBg = (score) => {
    if (score >= 95) return 'from-success/10 to-success/5 border-success/20';
    if (score >= 85) return 'from-warning/10 to-warning/5 border-warning/20';
    return 'from-error/10 to-error/5 border-error/20';
  };

  return (
    <div className="space-y-4">
      {/* Active Violations Card */}
      <div className="bg-gradient-to-br from-error/10 to-error/5 border border-error/20 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Active Violations</h3>
          <Icon name="AlertTriangle" size={20} color="var(--color-error)" />
        </div>
        <div className="text-center">
          <div className="text-5xl font-bold text-error mb-2">{activeViolations}</div>
          <p className="text-sm text-muted-foreground">Require Your Action</p>
        </div>
      </div>

      {/* Resolution Progress Card */}
      <div className="bg-gradient-to-br from-success/10 to-success/5 border border-success/20 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Resolved</h3>
          <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
        </div>
        <div className="text-center">
          <div className="text-5xl font-bold text-success mb-2">{resolvedViolations}</div>
          <p className="text-sm text-muted-foreground">Successfully Fixed</p>
        </div>
      </div>

      {/* Compliance Score Impact Card */}
      <div className={`bg-gradient-to-br border rounded-lg p-6 ${getScoreBg(complianceScore)}`}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Compliance Score</h3>
          <Icon name="TrendingUp" size={20} color={`var(--color-${getScoreColor(complianceScore)?.replace('text-', '')})`} />
        </div>
        <div className="text-center">
          <div className={`text-5xl font-bold mb-2 ${getScoreColor(complianceScore)}`}>
            {complianceScore}%
          </div>
          <p className="text-sm text-muted-foreground">Current Rating</p>
        </div>
        <div className="mt-4 pt-4 border-t border-border/50">
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Target Score</span>
            <span className="font-bold text-success">95%+</span>
          </div>
        </div>
      </div>

      {/* Deadline Tracking Card */}
      <div className="bg-gradient-to-br from-warning/10 to-warning/5 border border-warning/20 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Urgent Actions</h3>
          <Icon name="Clock" size={20} color="var(--color-warning)" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Due Today</span>
            <span className="text-lg font-bold text-error">{activeViolations > 0 ? Math.min(activeViolations, 3) : 0}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Due This Week</span>
            <span className="text-lg font-bold text-warning">{activeViolations}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViolationStatusOverview;